module.exports = __webpack_public_path__ + "static/img/Lato-Regular.70cfab5.svg";


//////////////////
// WEBPACK FOOTER
// ./static/font/Lato-Regular.svg
// module id = ILjl
// module chunks = 27